import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import "./styles.css";

const KendoInput = ({
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  onBlur,
  icon,
  disabled = false,
  readOnly = false,
  style = {},
  ContainerStyle = {},
  // Accessible name for inputs whose visible caption isn't a <label> (e.g. date pickers
  // under a SoftTypography heading). Only this attribute is forwarded; other props are
  // still dropped so existing callers render exactly as before.
  ariaLabel,
  // PIN and one-time-code fields: the phone keypad, a length cap and the browser's
  // autofill hint. Undefined for every other caller, so nothing changes for them.
  inputMode,
  maxLength,
  autoComplete,
  autoFocus,
}) => {
  return (
    <div className="kc-input-container" style={ContainerStyle}>
      <Input
        className={"kc-input"}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        name={name}
        disabled={disabled}
        readOnly={readOnly}
        style={style}
        aria-label={ariaLabel}
        inputMode={inputMode}
        maxLength={maxLength}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
      />
      {icon && <div className="kc-input-icon">{icon}</div>}
    </div>
  );
};

export default KendoInput;
